import React from 'react';
import { Link } from 'react-router-dom';
import { Col, Row } from 'reactstrap';

const BreadCrumb = ({ titleActive, titleInActive }) => {
  return (
    <>
      <Row>
        <Col xs={12}>
          <div className="page-title-box d-sm-flex align-items-center justify-content-between">
            {/* <h4 className="mb-sm-0 fw-medium text-uppercase fs-16">
              {titleActive}
            </h4> */}

            {/* <div className="page-title-right">
              <ol className="breadcrumb m-0">
                <li className="breadcrumb-item active">{titleInActive}</li>
                <li className="breadcrumb-item">{titleActive}</li>
              </ol>
            </div> */}
          </div>
        </Col>
      </Row>
    </>
  );
};

export default BreadCrumb;
